<template>
  <div class="container">
    <el-breadcrumb separator=">" class="title">
      <el-breadcrumb-item :to="{ path: '/course_list' }">课程管理</el-breadcrumb-item>
      <el-breadcrumb-item v-if="!form.uuid">新增课程</el-breadcrumb-item>
      <el-breadcrumb-item v-else>修改课程</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="id-wrapper" v-if="form.courseId">
      <div class="left">课程ID</div>
      <div class="right">
        {{form.courseId}}
      </div>
    </div>
    <div class="img-wrapper">
      <div class="left"><span>图片</span></div>
      <div class="right">
        <el-upload
          class="avatar-uploader"
          action="/basiCP/uploadFile"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload">
          <img v-if="showPic || form.pic" :src="showPic || form.pic" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
    </div>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" class="form">
      <el-form-item label="类型" prop="type">
        <el-radio-group v-model="form.type">
          <el-radio :label="1">单板</el-radio>
          <el-radio :label="2">双板</el-radio>
          <el-radio :label="3">高山安全</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="等级" prop="level">
        <el-select v-model="form.level" placeholder="请选择课程等级">
          <el-option label="蓝色" :value="1"></el-option>
          <el-option label="红色" :value="2"></el-option>
          <el-option label="黑色" :value="3"></el-option>
          <el-option label="颜色4" :value="4"></el-option>
          <el-option label="颜色5" :value="5"></el-option>
          <el-option label="颜色6" :value="6"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="课程名称" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="课程英文名称" prop="englishName">
        <el-input v-model="form.nameEnglish"></el-input>
      </el-form-item>
      <el-form-item label="价格" prop="price">
        <el-input v-model="form.price" type="number"></el-input>
      </el-form-item>
      <el-form-item label="课程详情" prop="detail">
        <el-input v-model="form.detail"></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">上架</el-radio>
          <el-radio :label="0">下架</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit(1)" v-if="!form.uuid" :loading="loading">立即创建</el-button>
        <el-button type="primary" @click="onSubmit(2)" v-else :loading="loading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script type="text/ecmascript-6">
  import { mapGetters } from 'vuex';
  import { courseUtil } from '@/api/course';
  import { trimString } from '@/common/js/util';

  export default {
    // name: 'add_course',
    data() {
      return {
        form: {
          courseId: '',
          pic: '',
          type: 1,
          level: '',
          name: '',
          nameEnglish: '',
          price: 0,
          detail: '',
          status: 1
        },
        showPic: '',
        rules: {
          type: [
            { required: true, message: '请选择类型', trigger: 'change' }
          ],
          level: [
            { required: true, message: '请选择等级', trigger: 'change' }
          ],
          name: [
            { required: true, message: '请输入课程名称', trigger: 'blur' }
          ],
          nameEnglish: [
            { required: true, message: '请输入课程英文名称', trigger: 'blur' }
          ],
          price: [
            { required: true, message: '请输入课程价格', trigger: 'blur' }
          ],
          detail: [
            { required: true, message: '请输入课程详情', trigger: 'blur' }
          ],
          status: [
            { required: true, message: '请选择状态', trigger: 'change' }
          ]
        },
        loading: false
      };
    },
    mounted() {
      if (this.$route.params.id) {
        this.form = Object.assign({}, this.form, this.course);
      }
    },
    methods: {
      handleAvatarSuccess(res, file) {
        this.form.pic = res.filePath;
        this.showPic = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png');
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      onSubmit(type) {
        if (!this.form.pic) {
          this.$message.warning('请上传课程图片');
          return;
        }
        if (!this.form.type) {
          this.$message.warning('请选择课程类型');
          return;
        }
        if (!this.form.name || !trimString(this.form.name)) {
          this.$message.warning('请输入课程名字');
          return;
        }
        if (!this.form.nameEnglish || !trimString(this.form.nameEnglish)) {
          this.$message.warning('请输入课程英文名字');
          return;
        }
        if (!this.form.price) {
          this.$message.warning('请输入课程价格');
          return;
        }
        this.loading = true;
        this.form.userId = this.user.userId;
        switch (type) {
          case 1:
            courseUtil(this.form, 1).then((res) => {
              this.loading = false;
              if (res.rspCode === 0) {
                this.$message.success('新增课程成功');
                this.$router.go(-1);
              } else {
                this.$message.error(res.rspDesc);
              }
            }).catch(e => {
              this.loading = false;
            });
            break;
          case 2:
            courseUtil(this.form, 2).then((res) => {
              this.loading = false;
              if (res.rspCode === 0) {
                this.$message.success('保存课程成功');
                this.$router.go(-1);
              } else {
                this.$message.error(res.rspDesc);
              }
            }).catch(e => {
              this.loading = false;
            });
            break;
        }
      }
    },
    computed: {
      ...mapGetters([
        'course',
        'user'
      ])
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .container
    .title
      margin-bottom: 20px;
    .id-wrapper
      display: flex;
      margin-bottom: 22px;
      .left
        flex: 0 0 120px;
        width: 120px;
        padding-right: 12px;
        box-sizing: border-box;
        text-align: right;
        font-size: 14px;
        color: #606266;
      .right
        flex: 1;
        font-size: 14px;
        color: #606266;
    .img-wrapper
      display: flex;
      margin-bottom: 22px;
      .left
        flex: 0 0 120px;
        width: 120px;
        padding-right: 12px;
        box-sizing: border-box;
        text-align: right;
        font-size: 14px;
        line-height: 120px;
        color: #606266;
        span:before
          content: '*';
          color: #F56C6C;
          margin-right: 4px;
      .right
        flex: 1;
        .avatar-uploader
        .el-upload
          width: 120px;
          height: 120px;
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          &:hover
            border-color: #409EFF;
        .avatar-uploader-icon
          font-size: 28px;
          color: #8c939d;
          width: 120px;
          height: 120px;
          line-height: 120px;
          text-align: center;
        .avatar
          width: 120px;
          height: 120px;
          display: block;
    .form
      width: 500px;
</style>